<template>
  <ui-component-modal
    :modalTitle="$t('Views.Settings.ModalEditExportGroupOptions.Main_Title')"
    :isSaving='isSaving'
    :isSavingSuccess='isSavingSuccess'
    :isSavingError='isSavingError'
    :hideFooterButtons='isSavingError || isSavingSuccess'
    :onClickCancel='onClickCancel'
    :onClickSave='goToSave'
    :showModal='showModal'
    @closeModal='onClickCancel'
  >
    <template slot='modalTitle'></template>
    <template v-slot:content>
      <div class="columns">
        <div class="column">
          <Message
            class="is-warning has-margin-bottom"
            :message="$t('Views.Settings.ModalEditExportGroupOptions.Message_Info')"
          />
        </div>
      </div>
      <div class="selected-options-wrapper">
        <div
          class="title is-3"
          v-html="$t('Views.Settings.ModalEditExportGroupOptions.HeaderTitle_SelectedOptions')"
        ></div>

        <Message
          v-if="selectedOptions.length === 0"
          :message="$t('Views.Settings.ModalEditExportGroupOptions.Message_NoOptions')"
        />

        <div class="wrapper-selectedOptions">
          <table class="table is-fullwidth is-hoverable is-striped">
            <tbody>
              <tr
                v-for="(option, index) in selectedOptions"
                :key="`sl${index}`"
              >
                <td :class="[{'is-strikethrough': option.IsDeleted,'has-text-grey': option.IsDeleted,}]">
                  {{ option.Name }}</td>
                <td
                  v-if="!option.IsDeleted"
                  width="18%"
                >
                  <a @click="deleteOption(option)">
                    <span class="icon">
                      <font-awesome-icon
                        :icon="['fas', 'trash-alt']"
                        style="color:red"
                      />
                    </span>
                  </a>
                </td>
                <td
                  v-if="option.IsDeleted"
                  width="18%"
                >
                  <a @click="restoreOption(option)">
                    <span class="icon">
                      <font-awesome-icon :icon="['fas', 'undo']" />
                    </span>
                    <span>{{$t('Views.Settings.ModalEditExportGroupOptions.Button_Undo')}}</span>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </ui-component-modal>
</template>

<script>
import optionProvider from '../../../providers/option'

const Message = () => import(/* webpackChunkName: "settings-options" */ '@/components/UI/Message')

export default {
  components: {
    Message
  },

  props: {
    showModal: {
      type: Boolean,
      default: false
    },

    onClickCancel: {
      type: Function,
      required: true
    },

    exportgroupOptions: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      isLoading: false,
      isSaving: false,
      isSavingSuccess: false,
      isSavingError: false,
      locationId: Number(this.$route.params.locationId),
      selectedOptions: [],
    }
  },

  computed: {
    // uniqueItemTypes() {
    //   let result = this.exportgroupOptions     

    //   //filter out duplicate ItemTypes in exportGroupOptions
    //   result = result.filter((options, index, self) =>
    //   index === self.findIndex((o) => (
    //   o.ItemType === options.ItemType ))
    //   )
    //   return result
    // },

    // filteredRemovedOptions() {
    //   let result = this.removedOptions

    //   result = result.filter(
    //     (option) => option.ItemType === this.infoTab
    //   )
    //   return result
    // },

  },

  created() {
    if (this.exportgroupOptions) {
      this.selectedOptions = JSON.parse(JSON.stringify(this.exportgroupOptions))
      this.selectedOptions = this.selectedOptions.filter(option => option.ItemType === "Option" && option.IsDeleted === false)
    }
  },

  methods: {
    restoreOption(option) {
      let index = this.selectedOptions.findIndex(
        (o) => o.Id === option.Id
      )
      if (index > -1) {
        this.selectedOptions[index].IsDeleted = false
      }
    },

    deleteOption(option) {
      let index = this.selectedOptions.findIndex(
        (o) => o.Id === option.Id
      )
      if (index > -1) {
        this.selectedOptions[index].IsDeleted = true
      }
    },

    async goToSave() {
      await this.selectedOptions.map(option => {
        option.IsDeleted ? this.save1(option) : null
      })
      this.isSavingSuccess = true
      this.isSaving = false
    },

    async save1(option) {
      let self = this
      self.isSaving = true

      await optionProvider.methods
        .getOptionById(option.ItemId, self.locationId)
        .then((response) => {
          if (response.status === 200) {
            this.save2(response.data)
              .catch((e) => {
                self.isSavingError = true
              })
          }
        }
        )
    },

    async save2(option) {
      let self = this

      optionProvider.methods
        .saveLocationOptionSettings(
          option.Id,
          option.Location.LocationId,
          option.Location.CategoryId,
          0,
          option.Location.RequiredItem,
          option.Location.TimeSelectable,
          option.Location.AvailableStart,
          option.Location.AvailableEnd,
          option.Location.TrackInventory,
          option.Location.CheckInventoryCapacity,
          option.Location.Inventory,
          option.Location.HoursBeforeReservation,
          option.Location.MaxAmount
        )
        .then((response) => {
          let t = setTimeout(() => {
            self.$emit('exportOptionsUpdated')
            self.onClickCancel()
            clearTimeout(t)
          }, 1500)
        })
        .catch((e) => {
          self.isSavingError = true
        })
    }
  }
}
</script>